export const TYPES = {
  SECTORIZED: 'sectorized',
  FULL: 'full',
};
